import React, {Component} from 'react';
import {
	Dialog,
	ExternalLoginLink,
	Spinner,
	ValidatingInput,
	Form,
	FancyCheckbox
} from '../widgets/';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';
import './LoginDialog.css';
import actions from './session.actions';
import fetchJson from '../fetchJson';
import ReactGA from 'react-ga';
import handleError from '../handleError';

const getEmailState = state => {
	if (state.validatingEmail) {
		// Checking validity
		return 'validating';
	}

	if (state.email && state.email.length > 0) {
		if (state.emailValidity === true) {
			// Email is definitely valid
			return 'valid';
		} else if (state.emailValidity === false) {
			// Email is definitely invalid
			return 'invalid';
		} else {
			return 'in_use'; // User is still typing
		}
	} else {
		// Nothing entered
		return 'required';
	}
};

const getPasswordState = state => {
	if (state.password && state.password.length > 0) {
		if (state.passwordValidity === true) {
			// PW is definitely valid
			return 'valid';
		} else if (state.passwordValidity === false) {
			// PW is definitely invalid
			return 'invalid';
		} else {
			return 'in_use'; // User is still typing
		}
	} else {
		// Nothing entered
		return 'required';
	}
};

const getConfirmPasswordState = state => {
	if (state.confirmPassword && state.confirmPassword.length > 0) {
		if (state.confirmPassword === state.password) {
			return 'valid';
		} else {
			return 'invalid';
		}
	} else {
		// Nothing entered
		return 'required';
	}
};

class LoginDialog extends Component {
	constructor() {
		super();

		this.state = {
			navigating: false,

			email: localStorage.getItem('userEmail') || '',
			emailValidity: null,
			emailValidated: false,
			password: '',
			passwordValidity: null,
			confirmPassword: '',
			validatingEmail: false,
			rememberUsername: !!localStorage.getItem('userEmail')
		};

		this.changeUsername = e => this.setState({email: e.target.value});
		this.changePassword = e => this.setState({password: e.target.value});
		this.changeRememberUsername = e => {
			if (this.state.rememberUsername) {
				// turning remember username off, clear from localStorage
				localStorage.removeItem('userEmail');
			}
			this.setState({rememberUsername: e.target.checked});
		};

		this.handleKeyPress = e => {
			if (e.key === 'Enter') {
				e.preventDefault();
			}

			if (
				e.key === 'Enter' &&
				this.state.email &&
				this.state.email.length &&
				this.state.password &&
				this.state.password.length >= 8 &&
				this.props.modal === 'login'
			) {
				this.login();
			}

			if (
				e.key === 'Enter' &&
				this.state.emailValidity === true &&
				this.state.password &&
				this.state.password.length >= 8 &&
				this.state.confirmPassword === this.state.password &&
				this.props.modal === 'signup'
			) {
				this.signup();
			}
		};
		this.login = () =>
			this.props.onLogin(this.state.email, this.state.password, this.state.rememberUsername);
		this.googleClick = () => {
			this.setState({navigating: true});
			ReactGA.event({
				category: this.props.modal === 'signup' ? 'On-boarding' : 'Session',
				action: this.props.modal === 'signup' ? 'Google sign-up' : 'Google auth'
			});
		};
		this.facebookClick = () => {
			this.setState({navigating: true});
			ReactGA.event({
				category: this.props.modal === 'signup' ? 'On-boarding' : 'Session',
				action: this.props.modal === 'signup' ? 'Facebook sign-up' : 'Facebook auth'
			});
		};
		this.twitterClick = () => {
			this.setState({navigating: true});
			ReactGA.event({
				category: this.props.modal === 'signup' ? 'On-boarding' : 'Session',
				action: this.props.modal === 'signup' ? 'Twitter sign-up' : 'Twitter auth'
			});
		};
		this.linkedinClick = () => {
			this.setState({navigating: true});
			ReactGA.event({
				category: this.props.modal === 'signup' ? 'On-boarding' : 'Session',
				action: this.props.modal === 'signup' ? 'LinkedIn sign-up' : 'LinkedIn auth'
			});
		};
		this.appleClick = () => {
			this.setState({navigating: true});
			ReactGA.event({
				category: this.props.modal === 'signup' ? 'On-boarding' : 'Session',
				action: this.props.modal === 'signup' ? 'Apple sign-up' : 'Apple auth'
			});
		};
		this.setEmail = e =>
			this.setState({
				email: e.target.value,
				emailValidity: null,
				emailValidated: false
			});
		this.setPassword = e => this.setState({password: e.target.value, passwordValidity: null});
		this.setConfirmPassword = e => this.setState({confirmPassword: e.target.value});
		this.signup = () => this.props.signup(this.state.email, this.state.password);
		this.validateEmail = () => {
			if (this.state.email && this.state.email.length && !this.state.emailValidated) {
				this.setState({
					validatingEmail: true,
					emailValidated: true
				});

				fetchJson(`/api/user/email/${this.state.email}/valid`)
					.then(result => {
						this.setState({
							emailValidity: result.valid,
							validatingEmail: false
						});
					})
					.catch(this.props.handleError);
			}
		};
		this.validatePassword = () => {
			this.setState({
				passwordValidity: !!(this.state.password && this.state.password.length >= 8)
			});
		};
	}

	render() {
		const {status, modal, onForgot} = this.props;

		const baseWord = modal === 'signup' ? 'Sign up' : 'Login';
		const externalLinkParams =
			modal === 'signup' ? '' : `?path=${encodeURIComponent(window.location.pathname)}`;

		return (
			<Dialog
				buttons={['cancel', modal === 'signup' ? 'sign up' : 'login']}
				disabled={{
					'sign up':
						this.state.emailValidity !== true ||
						!(this.state.password && this.state.password.length >= 8) ||
						this.state.confirmPassword !== this.state.password,
					login: !(
						this.state.email &&
						this.state.email.length &&
						this.state.password &&
						this.state.password.length >= 8
					)
				}}
				onLogin={this.login}
				onSignup={this.signup}
				onCancel={this.props.onCancel}
				title={modal === 'signup' ? 'Sign up' : 'Login'}
				emphasis={modal === 'signup' ? 'sign up' : 'login'}>
				<div className="LoginDialog">
					{modal === 'signup' && (
						<p>
							By signing up to <em>B2Me</em>, you choose to abide by the{' '}
							<a href="/terms201902_1.pdf" target="_blank" rel="noopener noreferrer">
								Terms of use
							</a>
						</p>
					)}
					{status === 'expired' && (
						<div className="LoginDialog-error">
							<span className="icon icon-error" />
							<span>Your session has expired, please log back in to continue.</span>
						</div>
					)}
					<p>
						{baseWord} to <em>B2Me</em> using:
					</p>
					<div className="LoginDialog-links">
						<ExternalLoginLink
							className="LoginDialog-externalLink"
							href={`/auth/google${externalLinkParams}`}
							backgroundColour="#db4437"
							icon="icon-adb"
							text={`${baseWord} via Google`}
							title={`${baseWord} to B2Me via Google`}
							onClick={this.googleClick}
						/>
						<ExternalLoginLink
							className="LoginDialog-externalLink"
							href={`/auth/facebook${externalLinkParams}`}
							backgroundColour="#3b5998"
							icon="icon-facebook2"
							text={`${baseWord} via Facebook`}
							title={`${baseWord} to B2Me via Facebook`}
							onClick={this.facebookClick}
						/>
						<ExternalLoginLink
							className="LoginDialog-externalLink"
							href={`/auth/twitter${externalLinkParams}`}
							backgroundColour="#1da1f2"
							icon="icon-twitter"
							text={`${baseWord} via Twitter`}
							title={`${baseWord} to B2Me via Twitter`}
							onClick={this.twitterClick}
						/>
						<ExternalLoginLink
							className="LoginDialog-externalLink"
							href={`/auth/linkedin${externalLinkParams}`}
							backgroundColour="#007bb5"
							icon="icon-linkedin"
							text={`${baseWord} via LinkedIn`}
							title={`${baseWord} to B2Me via LinkedIn`}
							onClick={this.linkedinClick}
						/>
						<ExternalLoginLink
							className="LoginDialog-externalLink"
							href={`/auth/apple${externalLinkParams}`}
							backgroundColour="#000"
							img="/img/apple.png"
							text={`${baseWord} via Apple`}
							title={`${baseWord} to B2Me via Apple`}
							onClick={this.appleClick}
						/>
					</div>
					{this.state.navigating && <Spinner />}

					<Form className="loginDialogForm">
						{modal === 'signup' && (
							<p>
								Otherwise specify an email address and password to create an account for{' '}
								<em>B2Me:</em>
							</p>
						)}
						{modal === 'login' && <p>Or with your email address and password:</p>}
						<div className="LoginDialog-field">
							<label htmlFor="email">Email</label>
							{modal === 'signup' && (
								<ValidatingInput
									id="email"
									name="username"
									autoComplete="username"
									type="email"
									placeholder="e.g. fred@b2me.com.au"
									onChange={this.setEmail}
									onKeyPress={this.handleKeyPress}
									value={this.state.email}
									onBlur={this.validateEmail}
									state={getEmailState(this.state)}
									states={{
										required: {
											message: 'Required',
											title: 'An email is mandatory for sign-up',
											icon: 'icon-warning',
											colour: '#ffc20e'
										},
										in_use: {
											message: '',
											title: ''
										},
										validating: {
											message: 'Checking...',
											title: 'Checking if this email is appropriate for use'
										},
										invalid: {
											message: '',
											title: 'This email address is invalid or taken',
											icon: 'icon-error',
											colour: 'red',
											caption: 'This email address is invalid or taken',
											captionStyle: {
												color: 'red'
											}
										},
										valid: {
											message: '',
											title: 'This email address is valid and available',
											icon: 'icon-check',
											colour: 'green'
										}
									}}
								/>
							)}
							{modal === 'login' && (
								<input
									id="email"
									name="username"
									autoComplete="username"
									type="email"
									onKeyPress={this.handleKeyPress}
									onChange={this.changeUsername}
									value={this.state.email}
								/>
							)}
						</div>
						<div className="LoginDialog-field">
							<label htmlFor="pw">Password</label>
							{modal === 'signup' && (
								<ValidatingInput
									id="pw"
									type="password"
									name="password"
									autoComplete="new-password"
									value={this.state.password}
									state={getPasswordState(this.state)}
									onBlur={this.validatePassword}
									onKeyPress={this.handleKeyPress}
									onChange={this.setPassword}
									states={{
										required: {
											message: 'Required',
											title: 'A password is mandatory for sign-up',
											icon: 'icon-warning',
											colour: '#ffc20e'
										},
										in_use: {
											message: '',
											title: ''
										},
										invalid: {
											message: '',
											title: 'This password is too short',
											icon: 'icon-error',
											colour: 'red',
											caption: 'This password is too short (minimum 8 characters)',
											captionStyle: {
												color: 'red'
											}
										},
										valid: {
											message: '',
											title: 'This password is valid',
											icon: 'icon-check',
											colour: 'green'
										}
									}}
								/>
							)}
							{modal === 'login' && (
								<input
									id="pw"
									type="password"
									name="password"
									autoComplete="current-password"
									onKeyPress={this.handleKeyPress}
									onChange={this.changePassword}
									value={this.state.password}
								/>
							)}
						</div>
						{modal === 'signup' && (
							<div className="LoginDialog-field">
								<label htmlFor="pwconfirm">Confirm password</label>
								<ValidatingInput
									id="pwconfirm"
									type="password"
									name="password"
									autoComplete="new-password"
									value={this.state.confirmPassword}
									state={getConfirmPasswordState(this.state)}
									onKeyPress={this.handleKeyPress}
									onChange={this.setConfirmPassword}
									states={{
										required: {
											message: 'Required',
											title: 'Please confirm your password by entering it a second time',
											icon: 'icon-warning',
											colour: '#ffc20e'
										},
										in_use: {
											message: '',
											title: ''
										},
										invalid: {
											message: '',
											title: 'The passwords do not match',
											icon: 'icon-error',
											colour: 'red',
											caption: 'The passwords do not match',
											captionStyle: {
												color: 'red'
											}
										},
										valid: {
											message: '',
											title: 'This password is valid',
											icon: 'icon-check',
											colour: 'green'
										}
									}}
								/>
							</div>
						)}
						<div className="LoginDialog-checkField">
							<FancyCheckbox
								id="rememberUsername"
								onChange={this.changeRememberUsername}
								checked={this.state.rememberUsername}
							/>
							<label htmlFor="rememberUsername">Remember email</label>
						</div>
					</Form>
					{status === 'waiting' && <Spinner />}
					{status === 'error' && (
						<div className="LoginDialog-error">
							<span className="icon icon-error" />
							<span>The email or password you entered was incorrect.</span>
						</div>
					)}
					{modal === 'login' && (
						<p className="LoginDialog-footer">
							<a href="#" onClick={onForgot}>
								Forgot your password?
							</a>
						</p>
					)}
				</div>
			</Dialog>
		);
	}
}

const ConnectedLoginDialog = connect(
	state => ({
		modal: state.ui.modal,
		status: state.session && state.session.status
	}),
	dispatch => ({
		handleError: () => handleError(dispatch),
		signup: (email, password, rememberUser = false) => {
			dispatch(actions.signup(email, password));
			if (rememberUser) localStorage.setItem('userEmail', email);
		},
		onForgot: () => {
			dispatch(uiActions.uiModal(null));
			dispatch(uiActions.uiModal('forgot-password'));
		},
		onLogin: (email, password, rememberUser = false) => {
			dispatch(actions.login(email, password));
			dispatch(uiActions.uiModal(null));
			if (rememberUser) localStorage.setItem('userEmail', email);
		},
		onCancel: () => dispatch(uiActions.uiModal(null))
	})
)(LoginDialog);

export default ConnectedLoginDialog;



// WEBPACK FOOTER //
// ./src/user/LoginDialog.js